import { createContext } from 'react';
import { OnChangeContextType } from './type';

export const onChangeContext = createContext<OnChangeContextType>(undefined);
